import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const EDITABLE_ATTRIBUTE_CLASS_NAME = 'EditableAttribute';

export const EDITABLE_ATTRIBUTE_CLASS_SLOTS: Partial<
	keyof EditableAttributeClasses
>[] = ['root', 'inputWrapper', 'input', 'trailingControls'];

export type EditableAttributeClassSlot =
	(typeof EDITABLE_ATTRIBUTE_CLASS_SLOTS)[number];

export interface EditableAttributeClasses {
	root: string;
	inputWrapper: string;
	input: string;
	trailingControls: string;

	alignBottom: string;
	alignCenter: string;
	alignTop: string;
	appending: string;
	error: string;
	limitHeightToContainer: string;
	matchContainerHeight: string;
	multipleValues: string;
}

export type EditableAttributeClassKey = keyof EditableAttributeClasses;

export const getEditableAttributeUtilityClass = (slot: string) =>
	generateUtilityClass(EDITABLE_ATTRIBUTE_CLASS_NAME, slot);

export const editableAttributeClasses = generateUtilityClasses<
	keyof EditableAttributeClasses
>(EDITABLE_ATTRIBUTE_CLASS_NAME, [
	'root',
	'alignBottom',
	'alignCenter',
	'alignTop',
	'appending',
	'error',
	'inputWrapper',
	'input',
	'limitHeightToContainer',
	'matchContainerHeight',
	'multipleValues',
	'trailingControls',
]);

export default editableAttributeClasses;
